import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { useLocation, useParams } from 'react-router-dom'
import styles from './OrdersInfoModal.module.css'
import PopupHeader from '../PopupHeader/PopupHeader'
import { getCurrentOrder } from '../../redux/actions/ordersAction'
import DownloadAsDocumentButton from '../DownloadAsDocumentButton/DownloadAsDocumentButton'

interface OrdersInfoModalProps {
  isOpen: boolean
  onClose: () => void
}

const OrdersInfoModal: React.FC<OrdersInfoModalProps> = ({ isOpen, onClose }) => {
  const dispatch = useAppDispatch()

  const location = useLocation()

  const { token } = useAppSelector((state) => state.auth)

  const { claimId } = useParams<{ claimId: string }>()
  const { currentClaim } = useAppSelector((state) => state.claims)
  const [discountTotal, setDiscountTotal] = useState(0)
  const [serviceFeeTotal, setserviceFeeTotal] = useState(0)
  const [corkFeeTotal, setCorkFeeTotal] = useState(0)

  useEffect(() => {
    if (claimId && token) {
      dispatch(getCurrentOrder({ token, currentPlace: Number(claimId) }))
    }
  }, [dispatch, claimId, token])

  const discount = currentClaim?.discountAmount || currentClaim?.discountPercent
  const serviceFee = currentClaim?.serviceFeeAmount || currentClaim?.serviceFeePercent
  const corkFee = currentClaim?.corkFeeAmount || currentClaim?.corkFeePercent
  const orderList = currentClaim?.order?.orderDetails

  useEffect(() => {
    if (discount == currentClaim?.discountAmount) {
      setDiscountTotal(currentClaim?.order?.price - (currentClaim?.order?.price - Number(discount)))
    }
    if (discount == currentClaim?.discountPercent) {
      setDiscountTotal(
        -(
          currentClaim?.order?.price -
          currentClaim?.order?.price -
          (currentClaim?.order?.price * Number(discount)) / 100
        ),
      )
    }

    const foodProductsTotal =
      orderList?.reduce((sum, item) => {
        const categoryType = item.category && 'type' in item.category ? item.category.type : null
        if (categoryType === 'food') {
          return sum + item.price * item.quantity
        }
        return sum
      }, 0) || 0

    const alcoholProductsTotal =
      orderList?.reduce((sum, item) => {
        const categoryType = item.category && 'type' in item.category ? item.category.type : null
        if (categoryType === 'alcohol') {
          return sum + item.price * item.quantity
        }
        return sum
      }, 0) || 0

    if (serviceFee == currentClaim?.serviceFeeAmount) {
      setserviceFeeTotal(Number(serviceFee))
    }
    if (serviceFee == currentClaim?.serviceFeePercent) {
      setserviceFeeTotal(Math.round((foodProductsTotal * Number(serviceFee)) / 100))
    }

    if (corkFee == currentClaim?.corkFeeAmount) {
      setCorkFeeTotal(Number(corkFee))
    }
    if (corkFee == currentClaim?.corkFeePercent) {
      setCorkFeeTotal(Math.round((alcoholProductsTotal * Number(corkFee)) / 100))
    }
  }, [dispatch, location, currentClaim])
  if (!isOpen) return null

  const smet = [discountTotal, serviceFeeTotal, corkFeeTotal, currentClaim?.order?.totalPrice]
  return (
    <div className={styles.createMenuModalOverlay}>
      <div className={styles.createMenuModal}>
        <PopupHeader title={'Мои Заказы'} onClickHandler={onClose} />

        {currentClaim?.order && currentClaim?.order?.orderDetails ? (
          <div>
            <div className={styles.titleBlock}>
              <h3>Заказ №{currentClaim.order.id}</h3>
            </div>
            <ul>
              {currentClaim?.order?.orderDetails.map((detail, index) => (
                <li key={index} className={styles.orderItem}>
                  <p>{detail.name}</p>
                  <p>
                    {' ' + detail.quantity}x<span>{' ' + detail?.price} руб.</span>
                  </p>
                </li>
              ))}
            </ul>
            <div className={styles.mainInfo}>
              <div className={styles.totalPriceBlock}>
                <h3>
                  Скидка {discount == currentClaim?.discountPercent ? discount : ''}{' '}
                  {discount == currentClaim?.discountPercent ? '%' : ''}
                </h3>
                <h2>{discountTotal} руб.</h2>
              </div>
              <div className={styles.totalPriceBlock}>
                <h3>
                  Сервисный сбор {serviceFee == currentClaim?.serviceFeePercent ? serviceFee : ''}
                  {serviceFee == currentClaim?.serviceFeePercent ? '%' : ''}
                </h3>
                <h2>{serviceFeeTotal} руб.</h2>
              </div>
              <div className={styles.totalPriceBlock}>
                <h3>
                  Пробковый сбор {corkFee == currentClaim?.corkFeePercent ? corkFee : ''}
                  {corkFee == currentClaim?.corkFeePercent ? '%' : ''}
                </h3>
                <h2>{corkFeeTotal} руб.</h2>
              </div>
              <div className={styles.totalPriceBlock}>
                <h3>Сумма заказа без учета скидок и сборов</h3>
                <h2>{currentClaim?.order?.price} руб.</h2>
              </div>
              <div className={styles.endingBlock}>
                <h3>Итоговая сумма заказа</h3>
                <h2>{currentClaim?.order?.totalPrice} руб.</h2>
              </div>
            </div>
          </div>
        ) : (
          <p>No order details available</p>
        )}
        <DownloadAsDocumentButton data={orderList} smet={smet} key={''} />
      </div>
    </div>
  )
}

export default OrdersInfoModal
